<ng-content></ng-content>

<ng-container *ngIf="showOverlay">
  <ng-container *ngIf="!asPopup">
    <dap-lib-button
      (click)="animateOut = true"
      [class.animate-out]="animateOut"
      buttonSize="large"
      class="shrink close-button"
      iconName="cross-small"
      iconPosition="left"
      iconSize="24"
      variant="white-violet"
      data-analytics="contact-overlay_close"
      >{{ 'CONTACT_OVERLAY.CLOSE' | translate }}
    </dap-lib-button>
    <div (animationend)="onAnimationEnd($event)" [class.animate-out]="animateOut" class="overlay">
      <ssc-contact-overlay-content
        [padded]="true"
        [title]="'CONTACT_OVERLAY.TITLE' | translate"
      ></ssc-contact-overlay-content>
    </div>

    <dap-lib-overlay-backdrop (click)="animateOut = true" *ngIf="animateOut === false"></dap-lib-overlay-backdrop>

    <dap-lib-scroll-lock></dap-lib-scroll-lock>
  </ng-container>

  <dap-lib-popup
    (cancel)="overlayClosed.emit()"
    *ngIf="asPopup"
    variant="violet"
    [isOpen]="true"
    [title]="'CONTACT_OVERLAY.TITLE' | translate"
  >
    <ssc-contact-overlay-content ngProjectAs="content"></ssc-contact-overlay-content>
  </dap-lib-popup>
</ng-container>
